// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3_O15","column":"style_column__3YpYx","row":"style_row__2YJ0E"};